// export const API_BASE_URL = 'https://sandbox-api.emmacare-dev.com/api'
export const API_BASE_URL =
  process.env.API_URL || 'https://sandbox-api.emmacare-dev.com/api'

export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
}

export const VERSION_URL = 'https://version.emmacare.com'

export const WEBSOCKET_API_KEY =
  process.env.WEBSOCKET_API_KEY || '1Bq9xExsBdKpvivNPnbLWub6sOXdnnU4c5S5AnnQ'

export const DEVTOOLS = process.env.DEVTOOLS || false

export const CURRENT_PORTAL_VERSION = '26.09.02'
